// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b0e61dac","611":"bc931145","703":"4fdb788b","787":"245e030e"}[chunkId] + ".chunk.js";
};